// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Grid, Transition, Loader, Message, Icon, Card, Placeholder } from 'semantic-ui-react'
import moment from 'moment'
import Img from 'react-image'
import renderHTML from 'react-render-html'
import ScrollArea from '@xico2k/react-scroll-area'
import validUrl from 'valid-url'

const Entities = require('html-entities').XmlEntities
const entities = new Entities()

const ImgLoader = (
  <Placeholder fluid style={{ height: 100 }}>
    <Placeholder.Image />
  </Placeholder>
)

const SingleLoader = (
  <div style={{ marginBottom: 20 }}>
    <Placeholder fluid style={{ height: 200 }}>
      <Placeholder.Image />
    </Placeholder>
  </div>
)

export default class UserWordPress extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: [],
      init: true,
      theme: 'light',
      textColor: '#000'
    }
  }

  wordpressAPI = (e) => {
    this.setState({
      loading: true,
      error: null
    })
    var url = this.props.wplink + '/wp-json/wp/v2/posts?_embed&per_page=5'
    if (validUrl.isUri(this.props.wplink)) {
      fetch(url)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          this.blogInfo()
          this.setState({
            data: data,
            done: true,
            singlepost: false
          })
        })
        .catch((error) => {
          this.setState({
            error: error.toString(),
            loading: false
          })
        })
    } else {
      this.setState({ error: 'Badly formatted URL', loading: false })
    }
  }

  blogInfo = () => {
    var url = this.props.wplink + '/wp-json/'
    fetch(url)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        this.setState({
          blogTitle: data.name,
          blogDesc: data.description,
          loading: false,
          init: false
        })
      })
      .catch((error) => {
        this.setState({
          error: error.toString(),
          loading: false
        })
      })
  }

  singlepost = (item, index, e) => {
    this.setState({
      done: false,
      index: index,
      singlepost: true
    })
  }
  goBack = (e) => {
    this.setState({
      done: true,
      singlepost: false
    })
  }

  darkMode = () => {
    if (this.state.theme === 'light') {
      this.setState({
        bgColor: '#222',
        textColor: '#fff',
        theme: 'dark'
      })
    } else if (this.state.theme === 'dark') {
      this.setState({
        bgColor: '#fff',
        textColor: '#222',
        theme: 'light'
      })
    }
  }

  render () {
    let { loading, done, error, singlepost, index, blogTitle, init, textColor, theme, bgColor} = this.state
    const posts = this.state.data.map((item, index) => (
      <Card
        style={{ borderWidth: 0, backgroundColor: theme === 'dark' ? '#000' : '#fff' }}
        link
        key={index}
        onClick={() => this.singlepost(index, item)}>
        {item._embedded['wp:featuredmedia'] !== undefined && (
          <Img
            decode={false}
            src={item._embedded['wp:featuredmedia'][0].source_url}
            loader={ImgLoader}
            style={{ width: '100%', resizeMode: 'contain' }}
            alt='featured-media'
            unloader={ImgLoader}
          />
        )}
        <Card.Content>
          <div style={{ color: textColor }}>
            <h4>{moment(item.date, 'YYYYMMDD').format('ll')}</h4>
            <h3 style={{ color: textColor, fontWeight: '900' }}>
              {entities.decode(item.title.rendered)}
            </h3>
          </div>
          <div
            style={{
              outline: 'none',
              color: textColor,
              fontSize: 14
            }}>
            {renderHTML(item.excerpt.rendered)}
          </div>
        </Card.Content>
      </Card>
    ))
    return (
      <div
        className='newframe-content'
        style={{
          backgroundColor: bgColor,
          color: textColor
        }}>
        <div className='containerX' />
        <div className='newframe-content-body'>
          <div
            style={{
              backgroundColor: 'transparent',
              marginLeft: '14px',
              marginRight: '14px',
              paddingBottom: '14px'
            }}>
            <Grid verticalAlign='middle'>
              {singlepost && !loading && !error && !done && (
                <Grid.Column width='5'>
                  <Icon
                    className='cursor'
                    style={{
                      color: theme === 'light' ? '#000' : '#fff'
                    }}
                    name='angle left'
                    size='large'
                    onClick={this.goBack}
                  />
                </Grid.Column>
              )}
              {done && !error && !singlepost && !loading && (
                <Grid.Column width='5' floated='left'>
                  <div style={{ marginLeft: '10px' }}>
                    <h3 style={{ color: textColor, whiteSpace: 'nowrap' }}>{blogTitle}</h3>
                  </div>
                </Grid.Column>
              )}
              <Grid.Column width='5' floated='right' textAlign='right' className='cursor'>
                {!init && (
                  <Icon
                    onClick={this.darkMode}
                    name='moon'
                    style={{ color: theme === 'light' ? '#000' : '#fff', fontSize: 15 }}
                  />
                )}
              </Grid.Column>
            </Grid>
          </div>
          {error && (
            <div className='centerX'>
              <Message
                style={{
                  marginLeft: '3vh',
                  marginRight: '3vh'
                }}>
                <Message.Header style={{ color: '#d54e21' }}>{error.toString()}</Message.Header>
              </Message>
            </div>
          )}

          {loading && (
            <div className='centerX mt'>
              <Loader active inline='centered'>
                Loading...
              </Loader>
            </div>
          )}

          {!error && init && !loading && (
            <div className='centerX' style={{ height: '550px' }}>
              <Icon name='wordpress' size='huge' style={{ color: '#21759b' }} />
            </div>
          )}

          <Transition visible={done} animation='scale' duration={800}>
            <div>
              {done && !loading && !error && (
                <ScrollArea trackHidden height='560px'>
                  <Card.Group
                    style={{
                      height: '472px',
                      margin: 10
                    }}
                    centered>
                    {posts}
                  </Card.Group>
                </ScrollArea>
              )}
            </div>
          </Transition>

          <Transition visible={singlepost} animation='horizontal flip' duration={500}>
            <div>
              {singlepost && !loading && !error && !done && (
                <ScrollArea trackHidden height='560px'>
                  <div
                    style={{
                      backgroundColor: 'transparent',
                      color: textColor
                    }}>
                    {index._embedded['wp:featuredmedia'] !== undefined && (
                      <Img
                        decode={false}
                        src={
                          index._embedded['wp:featuredmedia'][0].media_details.sizes.large
                            .source_url
                        }
                        loader={SingleLoader}
                        style={{
                          width: '100%',
                          resizeMode: 'cover',
                          minHeight: 200,
                          marginBottom: '2vh'
                        }}
                        alt='featured-media'
                        unloader={ImgLoader}
                      />
                    )}
                    <div
                      style={{
                        paddingLeft: 14,
                        backgroundColor: 'transparent',
                        color: textColor
                      }}>
                      <h3 style={{ color: textColor }}>{entities.decode(index.title.rendered)}</h3>
                      <h4>{moment(index.date, 'YYYYMMDD').format('ll')}</h4>
                    </div>
                    <div
                      style={{
                        outline: 'none',
                        margin: 14,
                        flex: 1,
                        height: '100%',
                        backgroundColor: 'transparent',
                        color: textColor
                      }}>
                      {renderHTML(index.content.rendered)}
                    </div>
                  </div>
                </ScrollArea>
              )}
            </div>
          </Transition>
        </div>
      </div>
    )
  }
}
